import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7.5 7.5l4.5 4.5l4.5 -4.5","key":"svg-0"}],["path",{"d":"M6 16v-4","key":"svg-1"}],["path",{"d":"M18 16v-4","key":"svg-2"}],["path",{"d":"M16 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M16 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-4"}],["path",{"d":"M4 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-5"}],["path",{"d":"M4 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-6"}]]

const IconMicrofrontends = createReactComponent('outline', 'microfrontends', 'Microfrontends', __iconNode);

export default IconMicrofrontends;